const Banner = '/assets/expresosantacruz/general/expresosantacruz_banner.jpg';
const HeaderLogo = '/assets/kennybus/general/kennybus-header-logo.png';
const FooterLogo = '/assets/kennybus/general/kennybus-footer-logo-white.png';
const BookingInActive = '/assets/expresosantacruz/general/booking_white.svg';
const BookingActive = '/assets/expresosantacruz/general/booking.svg';
const CancelInActive = '/assets/expresosantacruz/general/cancel_white.svg';
const CancelActive = '/assets/expresosantacruz/general/cancel.svg';

const Whatsapp = '/assets/expresosantacruz/icons/whatsapp.svg';
const Email = '/assets/expresosantacruz/icons/email.svg';
const HeadPhone = '/assets/expresosantacruz/icons/headphone.svg';
const YellowLine = '/assets/expresosantacruz/icons/line.svg';

const OriginIcon = '/assets/expresosantacruz/icons/origin-new.svg';
const DestinationIcon = '/assets/expresosantacruz/icons/destination-new.svg';
const pin = '/assets/expresosantacruz/icons/pin.svg';
const CalendarIcon = '/assets/combarbala/icons/calendar.svg';

const checkboxIcon = '/static/images/icons/bus-operator-new-checkbox.png';
const animation = '/static/images/animations/Services-kupos-PasajeBus-Orange.gif';
const pnr = '/assets/expresosantacruz/general/find-my-pnr.svg';

const PopupIcon = '/assets/kennybus/general/Pop-up.jpg';
const close2 = '/assets/cormarbus/icons/close-icon-2.svg';
// Icons Section
const ist = '/assets/expresosantacruz/icons/seat-icon.svg';
const second = '/assets/expresosantacruz/icons/best-services.svg';
const third = '/assets/expresosantacruz/icons/ticket-icon.svg';
const close = '/assets/kennybus/icons/close.svg';

const success = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-CheckMark-Orange.svg';
const failure = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-Information-Orange.svg';

const tick = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-Tick-Orange.svg';
const heartOn = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-HeartOn-Orange.svg';
const heartOff = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-HeartOff-Orange.svg';
const downArrow = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-DropDown-Orange.svg';
const registrationSuccess = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-RightDocument-Orange.svg';
const userIcon = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-Login-Orange.svg';
const trips = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-MyTrips-Orange.svg';
const cards = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-MyCards-Orange.svg';
const wallet = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-RechargeWallet-Orange.svg';
const transaction = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-ShareMoney-Orange.svg';
const otp = '/assets/jetsur/Orange/MyAccount-IllustratedIcons-RestorePassword-Orange.svg';

//const operatorPay = '/static/images/cormarpay-logo.jpg';


const petseatref = '/assets/expresosantacruz/icons/Expresso Santa Cruz-SeatPick-PetsOnBoard_Pet Paw Icon (Amenite).png';
const petseatModal = '/assets/expresosantacruz/icons/Expreso santa Cruz-PopUp-mascotas-no button.png';
const petfilteroff = '/assets/traveltur/pet/PetsOnBoard-Button-Filter_Off.png';
const petfilteron = '/static/images/seats/On-Button-Filter.svg';


const expresoSantaCruzIcons = [
	{ icon: downArrow, name: 'downArrow' },
	{ icon: userIcon, name: 'userIcon' },
	{ icon: trips, name: 'trips' },
	{ icon: cards, name: 'cards' },
	{ icon: wallet, name: 'wallet' },
	{ icon: transaction, name: 'transaction' },
	{ icon: success, name: 'success' },
	{ icon: failure, name: 'failure' },
	{ icon: tick, name: 'tick' },
	{ icon: heartOn, name: 'heartOn' },
	{ icon: heartOff, name: 'heartOff' },
	{ icon: registrationSuccess, name: 'registrationSuccess' },
	{ icon: otp, name: 'otp' },

	{ icon: Banner, name: 'Banner' },

	{ icon: HeaderLogo, name: 'headerLogo' },
	{ icon: FooterLogo, name: 'footerLogo' },
	{ icon: success, name: 'success' },
	{ icon: failure, name: 'failure' },

	{ icon: OriginIcon, name: 'Origin' },
	{ icon: DestinationIcon, name: 'Destination' },
	{ icon: pin, name: 'pin' },
	{ icon: CalendarIcon, name: 'Calendar' },

	{ icon: BookingInActive, name: 'BIA' },
	{ icon: BookingActive, name: 'BA' },
	{ icon: CancelInActive, name: 'CIA' },
	{ icon: CancelActive, name: 'CA' },

	{ icon: PopupIcon, name: 'Popup' },

	{ icon: Whatsapp, name: 'Whatsapp' },
	{ icon: Email, name: 'Email' },
	{ icon: HeadPhone, name: 'Headphone' },
	{ icon: YellowLine, name: 'Line' },

	{ icon: animation, name: 'animation' },
	{ icon: checkboxIcon, name: 'Checkbox' },

	{ icon: close2, name: 'close2' },

	// Icons Section
	{ icon: ist, name: 'ist' },
	{ icon: second, name: 'second' },
	{ icon: third, name: 'third' },
	{ icon: pnr, name: 'pnr' },
	{ icon: close, name: 'close' },

	// { icon: operatorPay, name: 'operatorPay' },

	//  pet seat details
	{ icon: petseatref, name: 'petseatref' },
	{ icon: petseatModal, name: 'petseatModal' },
	{ icon: petfilteron, name: 'petfilteron' },
	{ icon: petfilteroff, name: 'petfilteroff' },


];

export default expresoSantaCruzIcons;



// WEBPACK FOOTER //
// ./src/features/themes/functions/getIcons/expresoSantaCruzIcons.js